import { BaseModel } from "model/BaseModel";
import CentroCustoUsuario from "./CentroCustoUsuario";

export default class CentroCusto implements BaseModel {

    id: number;
    codigo: string | null;
    nome: string;
    centroCustoUsuarios: CentroCustoUsuario[];

    constructor(
        id = 0,
        codigo = null,
        nome = '',
        centroCustoUsuarios: CentroCustoUsuario[] = [],
    ) {
        this.id = id;
        this.codigo = codigo;
        this.nome = nome;
        this.centroCustoUsuarios = centroCustoUsuarios;
    }
}
